import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import VerifyContactInfoWrapper from './VerifyContactInfoWrapper';
import * as SecurityHelper from '../../../helpers/securityHelper';

export default class ExternalVerifyContactInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account: null,
            verifiedAddress: null,
            done: false,
            showNotice: false,
            noticeType: 'error',
            noticeText: ''
        }

        this.getAccount = this.getAccount.bind(this);
        this.verificationRequired = this.verificationRequired.bind(this);
        this.verifyAddress = this.verifyAddress.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
    }

    getAccount() {
        this.setState({
            account: SecurityHelper.getAccount()
        });
    }

    async verificationRequired() {
        try {
            const url = `${process.env.API}/orders/orders/${this.props.orderID}/verification`;
            const response = await axios.get(url, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            if (!response.data.address_verification_required) {
                this.setState({
                    showNotice: false,
                    done: true
                }, this.props.callback);
            }
            else {
                this.getAccount();
            }
        }
        catch (error) {
            this.setState({
                showNotice: true,
                noticeType: 'error',
                noticeText: 'We were unable to determine whether or not this Order requires Address Verification.  Please contact the help desk to cancel this reservation.'
            })
        }
    }

    async verifyAddress() {
        try {
            const url = `${process.env.API}/accounts/address/verify`;
            const response = await axios.post(url, this.state.account.home_address, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            this.setState({
                showNotice: false,
                verifiedAddress: response.data
            });
        }
        catch (error) {
            this.setState({
                verifiedAddress: null,
                showNotice: true,
                noticeType: 'error',
                noticeText: 'An error occurred trying to verify this address. Please ensure you have a Street Address, as well as a City+State or ZIP before proceeding.'
            });
        }
    }

    async saveProfile(updatedAccount) {
        try {
            const url = `${process.env.API}/accounts/orders/${this.props.orderID}/address`;
            await axios.post(url, updatedAccount, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            this.setState({
                showNotice: false,
                done: true
            }, this.props.callback);
        }
        catch (error) {
            this.setState({
                verifiedAddress: null,
                showNotice: true,
                noticeType: 'error',
                noticeText: 'An error occurred trying to Update this Address.'
            });
        }
    }

    render() {
        return (
            <div className="rec-verify-contact-info-wrapper">
                <VerifyContactInfoWrapper
                    account={this.state.account}
                    orderID={this.props.orderID}
                    saveProfile={this.saveProfile}
                    verifyAddress={this.verifyAddress}
                    verificationRequired={this.verificationRequired}
                    verifiedAddress={this.state.verifiedAddress}
                    showNotice={this.state.showNotice}
                    noticeType={this.state.noticeType}
                    noticeText={this.state.noticeText}
                    done={this.state.done} />
            </div>
        );
    }
}

ExternalVerifyContactInfo.propTypes = {
    orderID: PropTypes.string.isRequired,
    callback: PropTypes.func
};
